module.exports = __webpack_public_path__ + "static/media/5.e7f43f86.jpg";